import { Typography, Container, Box } from '@mui/material';
import { theme } from 'theme';



export const SelfService = () => {
   return (
      <Box component="section" sx={{ backgroundColor: theme.palette.grey[100], py: 8, paddingBottom: "2.5rem" }}>

         <Container>
            <Typography variant='h2' sx={{ marginBottom: "2rem", textAlign: "center" }}>
               Self Service Laundry in  {' '}
               <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                  Hamilton
               </Box>
            </Typography>

            <Box marginTop={"3rem"} paddingBottom={"3rem"}>


               <Typography sx={{ marginTop: { xs: "1.5rem", md: 0 } }}>
                  Our self-service laundry will perfectly meet your needs if you prefer doing your own laundry. Our eco-friendly laundry practices, including premium plant-based detergents, support sustainability and offer a clean environment to handle all your laundry. You can wash everything from everyday apparel to bulky sheets, bedding, towels, and more.
               </Typography>
               <Typography marginTop={"2rem"} >
                  We have a wide range of efficient and easy-to-operate washers and dryers that give you the perfect wash every time. Plus, you never have to worry about space at our laundry in Hamilton. We have ample folding tables in well-lit areas to help you quickly fold your clothes and move to the next item on your schedule.
               </Typography>
               <Typography marginTop={"2rem"} >
                  So, bring a book or listen to a podcast while our machines do their jobs and leave the best laundromat in Hamilton with fresh clothes.
               </Typography>

            </Box>
         </Container>
      </Box>
   );
}
